import { render, staticRenderFns } from "./matter_add.vue?vue&type=template&id=b0fd290c&scoped=true&"
import script from "./matter_add.vue?vue&type=script&lang=js&"
export * from "./matter_add.vue?vue&type=script&lang=js&"
import style0 from "./matter_add.vue?vue&type=style&index=0&id=b0fd290c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fd290c",
  null
  
)

export default component.exports